import { FC } from 'react';
import PageContainer from '@/components/PageContainer';
import { Typography } from '@mui/material';

/**
 * DebugPage
 */
const DebugPage: FC = () => {
  return (
    <PageContainer
      description="This page is for debugging purposes only. It will be remove once the app is in live"
      title="Debug Page"
    >
      <Typography mt={3} variant="h2">
        User Credentials
      </Typography>

      <ul style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <li>
          <Typography variant="h3" fontWeight="bold">
            Admin
          </Typography>
          <Typography variant="body1">Email: jorquera.ad@gmail.com</Typography>
          <Typography variant="body1">Password: jorquera.ad@gmail.com</Typography>
          <br />
          <Typography variant="body1">Email: jwalkermdinc@gmail.com</Typography>
        </li>
        <li>
          <Typography variant="h3" fontWeight="bold">
            Clinic Admin
          </Typography>
          <Typography variant="body1">Email: jorquera.ad+admin@gmail.com</Typography>
          <Typography variant="body1">Password: jorquera.ad+admin@gmail.com</Typography>
        </li>

        <li>
          <Typography variant="h3" fontWeight="bold">
            Doctor
          </Typography>
          <Typography variant="body1">Email: jorquera.ad+doctor@gmail.com</Typography>
          <Typography variant="body1">Password: jorquera.ad+doctor@gmail.com</Typography>
        </li>
      </ul>
    </PageContainer>
  );
};

export default DebugPage;
